import { GameMessage } from './messages'

export type DecodeResult =
  | { readonly ok: true; readonly value: GameMessage }
  | { readonly ok: false; readonly error: string }

/** 错误摘要上限，避免把过长信息写进日志。 */
const MAX_ERROR_LENGTH = 200

function summarize(
  issues: ReadonlyArray<{ readonly path: PropertyKey[]; readonly message: string }>,
): string {
  const text = issues
    .map((issue) =>
      issue.path.length === 0
        ? issue.message
        : `${issue.path.map((key) => String(key)).join('.')}: ${issue.message}`,
    )
    .join('; ')
  if (text.length <= MAX_ERROR_LENGTH) return text
  return `${text.slice(0, MAX_ERROR_LENGTH)}…`
}

/**
 * 校验收到的一帧数据。
 *
 * 任何非法输入（null、原始值、数组、缺字段、未知 type、越界坐标……）
 * 一律返回 `{ ok: false }`，绝不抛异常。失败时只 `console.warn` 一条摘要，
 * 且摘要只包含字段路径与 zod 的错误描述，不包含原始 payload 内容。
 */
export function decodeMessage(raw: unknown): DecodeResult {
  const result = GameMessage.safeParse(raw)
  if (result.success) return { ok: true, value: result.data }

  const error = summarize(result.error.issues)
  console.warn(`[protocol] 消息校验失败：${error}`)
  return { ok: false, error }
}

/** `decodeMessage` 的便捷版：失败返回 `null`。 */
export function parseMessage(raw: unknown): GameMessage | null {
  const result = decodeMessage(raw)
  return result.ok ? result.value : null
}
